module.exports = __webpack_public_path__ + "static/media/Thorsten_Buehlow.4fc44501.jpg";